<template>
    <div class="container-fluid">
        <div class="row project-cards">
            <div class="col-sm-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6">
                                <h2 class="text-2xl font-bold mb-2">Sección en Desarrollo</h2>
                                <p class="text-gray-500">Esta funcionalidad aún no está disponible. Estamos trabajando para lanzarla muy pronto.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'not_found',
    components: {
        
    },
    data(){
        return{
            
        }
    },
    mounted: async function() {
        
    },
}

</script>

<style scoped>
    .project-cards {
        padding-top: 30px;
    }
</style>